import { render, staticRenderFns } from "./MiddleEdit.vue?vue&type=template&id=ab463180&scoped=true&"
import script from "./MiddleEdit.vue?vue&type=script&lang=js&"
export * from "./MiddleEdit.vue?vue&type=script&lang=js&"
import style0 from "./MiddleEdit.vue?vue&type=style&index=0&id=ab463180&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab463180",
  null
  
)

export default component.exports